import PropTypes from 'prop-types'

import Helmet from '@s-ui/react-head'
import Layout from '@adv-mt/mt-layout-basic'
import MotorMarkdownWrapper from '@adv-mt/mt-markdown-wrapper/lib/Static'
import {PanelBasic} from '@adv-mt/mt-panel-basic'
import MotorTrackingCriteo from '@adv-mt/mt-tracking-criteo'
import TrackingPageView from '@adv-mt/mt-tracking-page-view'

import LinkFactory from '../../components/LinkFactory/index.js'
import {getInitialProps} from './getInitialProps.js'
import Skeleton from './Skeleton.js'

const Static = ({helmet = {}, pageName = '', markdownProps}) => {
  return (
    <Layout.Basic isPaddingless linkFactory={LinkFactory}>
      <PanelBasic>
        <div className="mt-Static">
          <MotorMarkdownWrapper {...markdownProps} />
        </div>
      </PanelBasic>
      <Helmet {...helmet} />
      <TrackingPageView pageName={pageName} />
      <MotorTrackingCriteo />
    </Layout.Basic>
  )
}

Static.displayName = 'Static'

Static.propTypes = {
  domain: PropTypes.object,
  helmet: PropTypes.object,
  pageName: PropTypes.string,
  markdownProps: PropTypes.shape({
    tenant: PropTypes.string.isRequired,
    documentName: PropTypes.string.isRequired
  })
}

Static.renderLoading = Skeleton

Static.getInitialProps = getInitialProps

export default Static
